import * as i from "../../../contracts";

export const mapRequiredProps = (league: i.League) => {
    league.id = league.id || "";
    league.sportId = league.sportId || "";
    league.name = league.name || "";

    return league;
}